<template>
  <v-dialog v-model="dialog" persistent max-width="950px">
    <v-card>
      <v-card-title>
        <span class="headline">{{
            item ? `Edit Alert` : 'New  Alert' }} </span>
        <v-spacer></v-spacer>
        <v-icon @click="closeDialog">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="formData.name"
                  label="Name"
                  placeholder="The alert name(be descriptive)"
                  persistent-placeholder
                  required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                  v-model="formData.type"
                  label="Type"
                  :items="alertTypes"
                  :values="formData.type"
                  placeholder="Select the alert type"
                  persistent-placeholder
                  required
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                  v-model="formData.message"
                  label="Message"
                  placeholder="The message that will appear on the Dashboard alerts"
                  persistent-placeholder
                  required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="!isFormValid" color="primary" @click="handleCreateOrUpdateAlert()">
          {{ isEdit ? 'UPDATE ALERT' : 'CREATE ALERT' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    item: {},
    value: Boolean,
  },
  data() {
    return {
      dialog: this.value,
      isEdit: false,
      availableId: null,
      formData: {
        name: "",
        type: "",
        message: "",
        status: "",
      },
      alertTypes: ["IMPORTANT_NOTIFICATION", "BE_ADVISED", "GOOD_TO_KNOW"],
    };
  },
  computed: {
    isFormValid() {
      return this.formData.name && this.formData.type && this.formData.message;
    },
  },
  methods: {
    handleCreateOrUpdateAlert() {
      this.$emit('createOrUpdateAlerts', this.formData);
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.formData = {
        id: null,
        name: '',
        type: '',
        message: '',
        status: '',
      };
      this.$emit('close');
    },
  },
  async mounted() {
    if (this.item) {
      this.isEdit = true;
      this.formData = {
        id: this.item.id,
        name: this.item.name,
        type: this.item.type,
        message: this.item.message,
        status: this.item.status,
        isEdit: true,
      };
    }
  },
};
</script>

<style scoped>
</style>
